enum DatasetType {
  BEFORE_MARKET_OPEN,
  MORNING,
  NOON,
  AFTERNOON
}

export default DatasetType
